import { Controller } from "@hotwired/stimulus";
import closeCollapse from "../utils/closeCollapse";
import openCollapse from "../utils/openCollapse";

export default class extends Controller<HTMLElement> {
  static targets = ["collapsible", "collapsibleHeader"];

  declare readonly collapsibleTarget: HTMLDivElement;
  declare readonly collapsibleTargets: HTMLDivElement[];
  declare readonly collapsibleHeaderTarget: HTMLDivElement;

  connect() {
    this.element.dataset.accordionReady = "true";
  }

  toggle({ target, params: { contentId } }: { params: { contentId: string } }) {
    this.collapsibleHeaderTarget.classList.toggle("active");

    if (target.classList.contains("disabled")) {
      return;
    }

    // Collapse
    this.collapsibleTargets.forEach((collapsible) => {
      const isTarget = collapsible.id === contentId;
      const header = this.element.querySelector(
        `[data-accordion-content-id-param="${collapsible.id}"]`
      );

      const disabled = header?.classList.contains("disabled");

      if (collapsible.classList.contains("open")) {
        closeCollapse(collapsible);
        header?.classList.remove("active");
      } else if (isTarget && !disabled) {
        openCollapse(collapsible);
        header?.classList.add("active");
      }
    });
  }
}
